export default "__VITE_ASSET__DKajY23q__"